// src/components/register/RegistrationWizard/ProgressBar.js
import React from 'react';

const ProgressBar = ({ currentStep, totalSteps }) => {
  // Calculate progress percentage
  const progressPercentage = (currentStep - 1) / (totalSteps - 1) * 100;
  
  // Generate step markers
  const steps = [];
  for (let i = 1; i <= totalSteps; i++) {
    steps.push(i);
  }
  
  // Define step labels
  const stepLabels = {
    1: 'Basic Details',
    2: 'Create Account',
    3: 'User Type',
    4: 'Personal Details',
    5: 'Educational Details'
  };
  
  return (
    <div className="progress-bar">
      <div className="progress-steps">
        {/* Line that fills based on progress */}
        <div className="progress-bar-line"></div>
        <div 
          className="progress-bar-line-filled" 
          style={{ width: `${progressPercentage}%` }}
        ></div>
        
        {/* Step circles */}
        {steps.map((step) => (
          <div 
            key={step}
            className={`progress-step ${
              step === currentStep 
                ? 'active' 
                : step < currentStep 
                  ? 'completed' 
                  : ''
            }`}
          >
            {step < currentStep ? '✓' : step}
            <span className="progress-step-label">{stepLabels[step]}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;